import { ConfigurationActions, IConfigurationAction } from './config.actions';

export interface ISiteInformation {
  client: string;
  path: string;
}

export function siteInformationReducer(state: ISiteInformation, action: IConfigurationAction) {
  switch (action.type) {
    // Since client selection is done from the DRC Portal, `client`
    // will probably never be updated from within this application
    case ConfigurationActions.UPDATE_SITE_INFORMATION:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;

  }
}
